/** Sums `px` tokens into one width. Used for table min-width so leftover columns cannot collapse to 0px. */
export const sumPxWidths = (...widths: readonly string[]): `${number}px` =>
  `${widths.reduce((total, width) => total + Number.parseInt(width, 10), 0)}px`

/** Fixed width for Balance, Balance N-1 and Variance amount columns — matches Figma overview (181px). */
export const SUPPLIERS_BALANCE_AMOUNT_COLUMN_WIDTH = '181px'

/** Label has no fixed width (absorbs leftover). Encoded in the table min-width — cell min-width is ignored under `table-layout: fixed`. */
export const SUPPLIERS_BALANCE_LABEL_MIN_WIDTH = '160px'

/** Account and Variance % are slightly above Figma (139 / 127) so unabbreviated labels + Lumen sort icons are not clipped. */
export const SUPPLIERS_BALANCE_COLUMN_WIDTHS = {
  accountNumber: '172px',
  amount: SUPPLIERS_BALANCE_AMOUNT_COLUMN_WIDTH,
  variancePercentage: '144px',
} as const

/** Fixed columns + Label leftover floor — enables horizontal scroll instead of a 0px Label on narrow viewports. */
export const SUPPLIERS_BALANCE_TABLE_MIN_WIDTH = sumPxWidths(
  SUPPLIERS_BALANCE_COLUMN_WIDTHS.accountNumber,
  SUPPLIERS_BALANCE_COLUMN_WIDTHS.amount,
  SUPPLIERS_BALANCE_COLUMN_WIDTHS.amount,
  SUPPLIERS_BALANCE_COLUMN_WIDTHS.amount,
  SUPPLIERS_BALANCE_COLUMN_WIDTHS.variancePercentage,
  SUPPLIERS_BALANCE_LABEL_MIN_WIDTH,
)
